import { apiGet } from '@/shared/utils/requestBuilder';
import type { Tribunal, TribunalFilters } from '@/types/tribunal/tribunalTypes';

export const tribunalService = {
  listar: async (filters?: TribunalFilters): Promise<{ data: Tribunal[]; total: number }> => {
    const params = new URLSearchParams();
    if (filters?.search) params.append('search', filters.search);
    if (filters?.sistemaAjuizamento)
      params.append('sistemaAjuizamento', filters.sistemaAjuizamento);
    if (filters?.sistemaProtocolo) params.append('sistemaProtocolo', filters.sistemaProtocolo);
    if (filters?.estado) params.append('estado', filters.estado);
    if (filters?.ativo !== undefined) params.append('ativo', String(filters.ativo));
    if (filters?.page) params.append('page', String(filters.page));
    if (filters?.limit) params.append('limit', String(filters.limit));

    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await apiGet(`/tribunais${query}`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao listar tribunais' }));
      throw new Error(errorData.error || 'Erro ao listar tribunais');
    }

    const result = await response.json();
    return {
      data: result.data || [],
      total: result.data?.length || 0,
    };
  },

  buscarPorId: async (id: string): Promise<Tribunal> => {
    const response = await apiGet(`/tribunais/${id}`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Tribunal não encontrado' }));
      throw new Error(errorData.error || 'Tribunal não encontrado');
    }

    const result = await response.json();
    return result.data;
  },

  buscarPorCodigo: async (codigo: string): Promise<Tribunal> => {
    const response = await apiGet(`/tribunais/codigo/${codigo}`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Tribunal não encontrado' }));
      throw new Error(errorData.error || 'Tribunal não encontrado');
    }

    const result = await response.json();
    return result.data;
  },

  buscarPorEstado: async (estado: string): Promise<Tribunal[]> => {
    const response = await apiGet(`/tribunais/estado/${estado}`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao buscar tribunais' }));
      throw new Error(errorData.error || 'Erro ao buscar tribunais');
    }

    const result = await response.json();
    return result.data || [];
  },
};
